import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { capitalizeWord } from "../utils";
import Text from "./Text";

const Wrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #ddd;
  padding-top: 12px;
  margin-top: 12px;
  & > div {
    flex-direction: row;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
  }
  & > .cartSummaryTotal {
    margin-top: 4px;
    margin-bottom: unset;
  }
`;

const TotalCartDiscount = ({
  intl,
  locales,
  subtotal,
  discount,
  otherPayment = {},
  handling = {},
  registration = {},
  setup_fee,
  totalAmount,
  error,
  shopper,
}) => {
  const showTotalCartDiscount = !!(
    discount ||
    otherPayment.total_with_tax ||
    handling.total_with_tax ||
    registration.total_with_tax ||
    setup_fee.total_with_tax?.value
  );

  return (
    showTotalCartDiscount && (
      <Wrap>
        <div data-testid="CartSummary_SubTotal">
          <div>
            <Text body2 secondary>
              {intl.formatMessage(locales.subtotal)}
            </Text>{" "}
          </div>
          <div>
            <Text body2 right primary error={error}>
              {subtotal}
            </Text>
          </div>
        </div>
        {discount ? (
          <div data-testid="CartSummary_Discount">
            <div>
              <Text body2 secondary>
                {intl.formatMessage(locales.discount)}
              </Text>
            </div>
            <div>
              <Text body2 primary right>
                -{discount}
              </Text>
            </div>
          </div>
        ) : null}
        {handling.total_with_tax && (
          <div data-testid="CartSummary_OtherPayment">
            <Text body2 secondary>
              {intl.formatMessage(locales.handling)}
            </Text>
            <Text body2 primary right>
              {handling.total_with_tax}
            </Text>
          </div>
        )}
        {registration.total_with_tax && (
          <div data-testid="CartSummary_OtherPayment">
            <Text body2 secondary>
              {intl.formatMessage(locales.registration)}
            </Text>
            <Text body2 primary right>
              {registration.total_with_tax}
            </Text>
          </div>
        )}
        {setup_fee.total_with_tax?.value && (
          <div data-testid="CartSummary_OtherPayment">
            <Text body2 secondary>
              {intl.formatMessage(locales.setup_fee)}
            </Text>
            <Text body2 primary right>
              {setup_fee.total_with_tax.string}
            </Text>
          </div>
        )}
        {otherPayment.total_with_tax && (
          <div data-testid="CartSummary_OtherPayment">
            <Text body2 secondary>
              {intl.formatMessage(locales.other_payment)}:
              {` ${capitalizeWord(otherPayment.name)}`}
            </Text>
            <Text body2 primary right>
              -{otherPayment.total_with_tax}
            </Text>
          </div>
        )}
        {totalAmount && (
          <div className="cartSummaryTotal" data-testid="CartSummary_Total">
            <Text body2 primary>
              {intl.formatMessage(locales.total)}
              {` ${shopper.quantity} ${shopper.text}`}
            </Text>
            <Text heading4 primary right>
              {totalAmount}
            </Text>
          </div>
        )}
      </Wrap>
    )
  );
};

TotalCartDiscount.propTypes = {
  intl: PropTypes.object,
  locales: PropTypes.object.isRequired,
  subtotal: PropTypes.string,
  discount: PropTypes.string,
  otherPayment: PropTypes.object,
  handling: PropTypes.object,
  registration: PropTypes.object,
  setup_fee: PropTypes.object,
  totalAmount: PropTypes.string,
  error: PropTypes.bool,
  shopper: PropTypes.object,
};

TotalCartDiscount.defaultProps = {
  intl: {
    formatMessage: (text) => text,
  },
  subtotal: "0,00 €",
  discount: null,
  otherPayment: {},
  handling: {},
  registration: {},
  setup_fee: {},
  totalAmount: null,
  error: false,
  shopper: { quantity: 0, text: "" },
};

export default TotalCartDiscount;
